module.exports = __webpack_public_path__ + "img/archive.c542ae04.svg";